<template>
  <pdp-section-size-and-fit />
</template>

<script lang="ts" setup>
import PdpSectionSizeAndFit from '#brand/regions/nora/components/pdp/section/SizeAndFit.vue'

const { $feature } = useNuxtApp()
const { brandClasses, sizeAndFit } = useAppConfig().pages.pdp

if ($feature.tempShowATCAboveFold) {
  brandClasses.sizeAndFitButton = 'elevate-body-4 my-4 flex items-center gap-2 underlined lg:my-2 lg:py-2 lg:text-xs'
  sizeAndFit.iconSize = { sm: 'lg', lg: 'sm' }
}
</script>
